import { ListItem } from './ListItem';

// TODO: in v9, move styled() from ListItem.jsx to here
export var StyledListItem = ListItem;